// extracted by mini-css-extract-plugin
module.exports = {"Auth":"Auth_Auth__28Tto","Input":"Auth_Input__1pTxX"};